import { Link } from "@tanstack/react-router";
import { Bath, Bed, MapPin, Maximize } from "lucide-react";
import type { Property } from "@/lib/mock-data";
import { StatusBadge } from "./StatusBadge";
import { CompareButton } from "./CompareButton";

export function PropertyCard({ property }: { property: Property }) {
  return (
    <Link
      to="/property/$id"
      params={{ id: property.id }}
      className="group flex flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-soft transition hover:-translate-y-0.5 hover:shadow-float"
    >
      <div className="relative">
        <img
          loading="lazy"
          decoding="async"
          src={property.image}
          alt={property.title}
          className="h-40 w-full object-cover"
        />
        <div className="absolute left-2 top-2">
          <StatusBadge purpose={property.purpose} />
        </div>
        <div className="absolute right-2 top-2">
          <CompareButton id={property.id} />
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3">
        <div className="flex items-start justify-between gap-2">
          <h4 className="line-clamp-1 text-sm font-semibold text-brown-dark">{property.title}</h4>
          <span className="text-sm font-bold text-coral">{property.priceLabel}</span>
        </div>
        <div className="flex items-center gap-1 text-[11px] text-muted-foreground">
          <MapPin className="h-3 w-3" /> {property.location}
        </div>
        <div className="mt-1 flex items-center gap-3 text-[11px] text-muted-foreground">
          {property.bedrooms && (
            <span className="flex items-center gap-1">
              <Bed className="h-3 w-3" /> {property.bedrooms}
            </span>
          )}
          {property.bathrooms && (
            <span className="flex items-center gap-1">
              <Bath className="h-3 w-3" /> {property.bathrooms}
            </span>
          )}
          <span className="flex items-center gap-1">
            <Maximize className="h-3 w-3" /> {property.areaSqft} ft²
          </span>
        </div>
      </div>
    </Link>
  );
}
